import React, { FC } from 'react';
import { Container, Title } from './ListBlock.styles';

export type ListComponentProps = SharedProps & {
  list: string[];
};

export interface SharedProps {
  title: string;
  multiline: boolean;
}

const ListBlock: FC<ListComponentProps> = ({ list, title, multiline }) => {
  return (
    <React.Fragment>
      {title && <Title>{title}</Title>}
      <Container>
        <ul>
          {list.map((item) => {
            return (
              <li key={item} className={multiline ? 'multiline' : ''}>
                <p>{item}</p>
              </li>
            );
          })}
        </ul>
      </Container>
    </React.Fragment>
  );
};

export default ListBlock;
